export default {
  zh: {
    // 首屏内容
    hero: {
      title: "呈现“真实客户案例”故事",
      titleHighlight: "赋能全球业务增长",
      description:
        "我们跨越制造、零售、金融、互联网等多个行业领域，基于真实业务需求设计<br />云上解决方案，让客户在降低成本的同时，释放更多创新潜能。",
    },
    // 案例展示区域
    section: {
      title: "成功案例展示",
      description:
        "我们与各行业的领先企业合作，通过专业的云成本管理方案，帮助他们实现了显著的成本降低和效率提升",
    },
    // 客户案例列表
    list: {
      tebian: {
        title: "特变电工",
        description:
          "作为全球知名的变压器制造商，特变电工通过Cycor一站式云成本管理方案，实现了多云环境下30%的成本节约和运维效率显著提升。",
      },
      kudi: {
        title: "KuDi Coffee",
        description:
          "快速发展的连锁咖啡品牌KuDi通过Cycor的云资源优化方案，在全球业务扩张过程中实现了云成本的精准控制和40%的资源利用率提升。",
      },
      zmaticoo: {
        title: "ZMaticoo",
        description:
          "作为领先的广告技术公司，ZMaticoo借助Cycor的智能分析平台，实现了大数据处理成本25%的降低和实时性能的显著优化。",
      },
      company4: {
        title: "创新科技",
        description:
          "通过Cycor的DevFinOps解决方案，创新科技在云原生转型过程中实现了开发成本可视化和35%的资源优化效果。",
      },
      company5: {
        title: "医疗健康",
        description:
          "借助Cycor的多云管理平台，医疗健康企业在合规性要求下实现了医疗数据处理成本的20%降低。",
      },
      company6: {
        title: "游戏娱乐",
        description:
          "通过Cycor的弹性资源管理，游戏公司在峰值流量处理中实现了50%的成本节约和用户体验的持续优化。",
      },
      company7: {
        title: "在线教育",
        description:
          "教育科技公司通过Cycor的SaaS成本优化方案，在用户快速增长期间保持了稳定的单位成本控制。",
      },
      company8: {
        title: "物流配送",
        description:
          "大型物流企业采用Cycor的大数据分析方案，实现了运输路径优化和仓储成本30%的有效降低。",
      },
      company9: {
        title: "媒体流媒体",
        description:
          "视频流媒体平台通过Cycor的CDN优化方案，在全球内容分发中实现了带宽成本45%的大幅节约。",
      },
      // Akool 案例
      akool: {
        title: "Akool｜生成式AI算力解决方案",
        challenge:
          "海量数据训练算力告急，模型迭代缓慢；高并发视频渲染显存消耗大，运营成本攀升；实时直播与会议场景推理延迟高，难以满足毫秒级要求。",
        solution:
          "提供高端GPU弹性算力，秒级扩缩容消除资源瓶颈；优化分布式训练框架，提升多模态模型迭代效率；自研推理加速技术降低显存占用，并开放主流大模型API加速产品落地。",
        results: {
          stability: {
            title: "系统稳定性跃升",
            desc: '攻克"角色闪烁"与"商品变形"，系统稳定性提升40%。',
          },
          efficiency: {
            title: "效率倍增",
            desc: "视频创作处理效率提升6倍，单路视频生成成本大幅下降。",
          },
          business: {
            title: "商业验证",
            desc: "成功支撑可口可乐全球营销、卡塔尔航空等标杆项目落地。",
          },
        },
        resultTitle: {
          h1: "赋能生成式AI独角兽",
          h2: "支撑全球3亿+ AI创意资产生成",
        },
      },
      kreadoAi: {
        title: "KreadoAI｜AIGC 营销智算方案",
        challenge:
          "全球领先 AI 营销内容平台，10 万+企业、月均 2 亿+内容；多模态训练 PB 级数据、迭代周期长，高并发生成 GPU 争抢推高成本，垂直行业微调慢。",
        solution:
          "异构 GPU 弹性集群支撑 PB 级并行训练；优化分布式框架，迭代周期缩短约 60%；剪枝与量化提升单卡吞吐、降低单位成本；开放 API 与工具链，行业适配自约 2 周压至约 3 天。",
        results: {
          perf: {
            title: "效能跃升",
            desc: "峰值并发处理能力约 +260%，从容应对大促峰值。",
          },
          cost: {
            title: "成本可控",
            desc: "单份内容生成成本降至约 $0.066，利润空间改善。",
          },
          growth: {
            title: "市场扩张",
            desc: "稳定算力支撑下，半年内新增海外客户约 3 万。",
          },
        },
        resultTitle: {
          h1: "AIGC 全链路降本增效",
          h2: "从训练到推理的规模化落地",
        },
      },
      qimiGames: {
        title: "Qimi Games｜手游 AI 与智算方案",
        challenge:
          "精品手游出海，全球玩家超千万；规则式 NPC 体验单一，剧情与关卡等内容生产周期长，小规模 GPU 难撑多游戏并行训练与稳定低延迟推理。",
        solution:
          "弹性 GPU 池按需分配，多模型并行、利用率显著提升；大模型微调赋予 NPC 动态决策；AIGC 文本 API 提效内容生产；推理链路优化，延迟由约 200ms 降至 50ms 内。",
        results: {
          experience: {
            title: "体验与营收",
            desc: "旗舰产品 30 日留存约 +22%，月流水约 +40%。",
          },
          efficiency: {
            title: "产能释放",
            desc: "单作内容周期由约 3 个月缩至约 18 天，小团队产能约 3 倍。",
          },
          cost: {
            title: "成本优化",
            desc: "算力按需付费，综合成本约降 40%。",
          },
        },
        resultTitle: {
          h1: "精品手游 AI 升级",
          h2: "NPC 智能与内容产能双突破",
        },
      },
      // 新增案例数据
      digitalEntertainment: {
        title: "数字娱乐｜全球化平台解决方案",
        challenge:
          "随着旗下主播与艺人矩阵的全球化扩张,面临海外直播延迟高、多语言内容合规难、海量用户数据实时处理与分析慢。",
        solution:
          "我们通过部署全球CDN与多区域微服务架构,降低了网络延迟。利用AI实现多语言实时翻译与智能内容审核,确保了本地化运营与内容合规。搭建实时数据流处理管道和数据仓库,实现了全球用户数据的统一分析与智能推荐。",
        results: {
          flow: {
            title: "全球体验流畅",
            desc: "通过多种方式优化网络路径,全球访问延迟降低50%以上。",
          },
          localization: {
            title: "内容智能本地化",
            desc: "支持20+种主流语言实时翻译与内容智能审核。",
          },
          engagement: {
            title: "用户粘性提升",
            desc: "个性化智能推荐模型将用户粘性提升了30%。",
          },
        },
        resultTitle: {
          h1: "构建全球娱乐生态",
          h2: "实现20亿粉丝的全球化触达和变现",
        },
      },
      sdwan: {
        title: "SD-WAN｜云原生网络解决方案",
        challenge:
          "传统MPLS专线成本高、部署慢，企业客户的多云环境需统一管理，全球网络节点监控与智能运维复杂。",
        solution:
          "我们助力其构建了下一代云原生SD-WAN平台。以全球骨干网替代传统昂贵专线；通过多云管理平台实现统一纳管与安全互联；并搭建AI智能运维平台，提供网络性能预测与秒级故障恢复能力。",
        results: {
          performance: {
            title: "网络性能跃升",
            desc: "全球网络延迟降低60%，网络可用性达到99.99%。",
          },
          deployment: {
            title: "部署效率提升",
            desc: "客户网络部署时间从数月缩短至数天，扩展速度提升3倍。",
          },
          maintenance: {
            title: "运维成本降低",
            desc: "网络运维成本降低50%，带宽利用率提升40%。",
          },
        },
        resultTitle: {
          h1: "服务世界五百强：毫秒级延迟",
          h2: "99.99%高可用全球网络",
        },
      },
      crossBorderEcommerce: {
        title: "跨境电商｜全球化技术解决方案",
        challenge:
          "全球用户访问延迟大、高并发流量，多产品线技术架构与资源分配需统一优化，并满足全球支付与数据合规要求。",
        solution:
          "我们为其构建了高性能、高可用的全球电商基础设施。部署全球CDN和智能负载均衡提升访问性能；构建GKE多区域微服务架构，支持多产品线独立部署和弹性扩展；并集成智能支付与合规安全体系，确保了跨境支付与全球合规安全。",
        results: {
          performance: {
            title: "全球性能提升",
            desc: "全球页面加载速度提升70%，移动端转化率提升25%。",
          },
          infrastructure: {
            title: "基础设施成本优化",
            desc: "基础设施成本降低40%，运维效率提升50%。",
          },
          experience: {
            title: "用户体验升级",
            desc: "全球用户满意度提升35%，客户留存率提升20%。",
          },
        },
        resultTitle: {
          h1: "支持三大产品线全球业务扩展",
          h2: "新增海外市场收入占比达到60%",
        },
      },
      gaming: {
        title: "游戏｜全球化技术解决方案",
        challenge:
          "需保障8亿全球用户的低延迟游戏体验，处理TB级游戏数据的实时分析，并实现基于文化的精准化运营。",
        solution:
          "我们为其构建了支撑8亿+用户的高性能游戏基础设施。构建全球低延迟游戏基础设施；搭建支持每秒百万级事件的海量数据处理与智能分析平台；并利用Firebase快速实现社交、用户追踪和消息推送等功能。",
        results: {
          experience: {
            title: "游戏体验提升",
            desc: "全球游戏延迟降低至50ms以内，用户体验满意度提升45%。",
          },
          growth: {
            title: "用户增长显著",
            desc: "新用户获取成本降低30%，用户留存率提升25%。",
          },
          monetization: {
            title: "商业化成果斐然",
            desc: "广告收入提升35%，内购转化率提升20%。",
          },
        },
        resultTitle: {
          h1: "支撑8亿+用户高性能游戏体验",
          h2: "助力文化游戏全球化发行",
        },
      },
      gamingSocial: {
        title: "游戏社交｜文化出海解决方案",
        challenge:
          "竞技游戏需毫秒级实时同步，社交产品需支持全球实时音视频互动，且文化内容需精准本地化并满足合规要求。",
        solution:
          "我们为其构建了全球化的游戏运营基础设施。通过Firebase和Agones on GKE等服务，保障游戏的实时同步与社交互动；搭建由VertexAI驱动的文化内容本地化平台，实现翻译、元素适配和智能审核；并建立海量数据分析体系。",
        results: {
          experience: {
            title: "全球体验极致",
            desc: "游戏延迟降低至30ms以内，全球用户满意度提升40%。",
          },
          localization: {
            title: "文化传播精准",
            desc: "文化内容本地化准确率达95%，文化认同度提升50%。",
          },
          value: {
            title: "商业价值提升",
            desc: "海外市场收入占比提升至45%，文化出海ROI提升80%。",
          },
        },
        resultTitle: {
          h1: "国家文化出口重点企业",
          h2: "助力中国文创产品走向世界",
        },
      },
      entertainment: {
        title: "泛娱乐｜全球内容平台解决方案",
        challenge:
          "4K超清内容的全球低成本分发与流畅播放，千万级并发下的AI个性化实时推荐，以及高并发的实时弹幕社区互动。",
        solution:
          "我们为其构建了全球化的内容分发与互动平台。通过Media CDN实现4K内容的低成本、高质量智能分发；利用VertexAI构建多模态实时个性化推荐引擎；并基于Firebase打造支持毫秒级同步的全球分布式弹幕系统。",
        results: {
          viewing: {
            title: "极致观影体验",
            desc: "4K HDR内容加载时间缩短60%，播放卡顿率降低80%。",
          },
          recommendation: {
            title: "精准个性化推荐",
            desc: "用户内容发现效率提升40%，平均观看时长增加35%。",
          },
          community: {
            title: "社区高度活跃",
            desc: "实时互动响应时间控制在50ms内，用户参与度提升50%。",
          },
        },
        resultTitle: {
          h1: "实现全球用户的极致观影体验和",
          h2: "内容创作者的全方位赋能",
        },
      },
    },
    // 标签系统
    tags: {
      manufacturing: "制造业",
      digital: "数字化转型",
      retail: "零售连锁",
      global: "全球化",
      adtech: "广告技术",
      optimization: "成本优化",
      finance: "金融科技",
      cloud: "云原生",
      healthcare: "医疗健康",
      ai: "人工智能",
      gaming: "游戏娱乐",
      infrastructure: "基础设施",
      education: "在线教育",
      saas: "SaaS平台",
      logistics: "物流配送",
      bigdata: "大数据",
      media: "媒体娱乐",
      streaming: "流媒体",
      // 新增标签
      entertainment: "娱乐",
      sdwan: "SD-WAN",
      ecommerce: "电商",
      socialGaming: "社交游戏",
      culturalExport: "文化出海",
      contentPlatform: "内容平台",
    },
    // 操作按钮
    loadMore: "查看更多案例",
    loadMoreButton: "查看更多",
    // 联系按钮
    contactUs: "联系我们",
  },
  en: {
    // Hero section
    hero: {
      title: 'Presenting "Real Customer Case" Stories',
      titleHighlight: "Empowering Global Business Growth",
      description:
        "We span across manufacturing, retail, finance, internet and other industries, designing<br />cloud solutions based on real business needs, helping customers reduce costs while unleashing more innovation potential.",
    },
    // Cases showcase section
    section: {
      title: "Success Stories",
      description:
        "We partner with leading enterprises across industries, helping them achieve significant cost reduction and efficiency improvement through professional cloud cost management solutions",
    },
    // Customer case list
    list: {
      tebian: {
        title: "TBEA",
        description:
          "As a globally renowned transformer manufacturer, TBEA achieved 30% cost savings and significant operational efficiency improvement in multi-cloud environments through Cycor's one-stop cloud cost management solution.",
      },
      kudi: {
        title: "KuDi Coffee",
        description:
          "Fast-growing coffee chain KuDi achieved precise cloud cost control and 40% resource utilization improvement during global business expansion through Cycor's cloud resource optimization solution.",
      },
      zmaticoo: {
        title: "ZMaticoo",
        description:
          "As a leading advertising technology company, ZMaticoo achieved 25% reduction in big data processing costs and significant real-time performance optimization through Cycor's intelligent analytics platform.",
      },
      company4: {
        title: "InnoTech",
        description:
          "Through Cycor's DevFinOps solution, InnoTech achieved development cost visibility and 35% resource optimization during cloud-native transformation.",
      },
      company5: {
        title: "HealthCare Plus",
        description:
          "With Cycor's multi-cloud management platform, healthcare enterprises achieved 20% reduction in medical data processing costs under compliance requirements.",
      },
      company6: {
        title: "GameZone",
        description:
          "Through Cycor's elastic resource management, the gaming company achieved 50% cost savings in peak traffic handling and continuous user experience optimization.",
      },
      company7: {
        title: "EduTech Online",
        description:
          "Educational technology companies maintained stable unit cost control during rapid user growth through Cycor's SaaS cost optimization solution.",
      },
      company8: {
        title: "LogiFlow",
        description:
          "Large logistics enterprises achieved transportation route optimization and 30% effective reduction in warehousing costs through Cycor's big data analytics solution.",
      },
      company9: {
        title: "StreamMedia Pro",
        description:
          "Video streaming platforms achieved 45% significant bandwidth cost savings in global content distribution through Cycor's CDN optimization solution.",
      },
      // Akool case
      akool: {
        title: "Akool | Generative AI Computing Solution",
        challenge:
          "Massive data training strains GPU resources, slowing model iteration; high-concurrency video rendering drives up memory costs; real-time streaming and meeting scenarios demand sub-millisecond inference that legacy infrastructure cannot deliver.",
        solution:
          "Elastic high-end GPU clusters with second-level auto-scaling; optimized distributed training to accelerate multimodal model iteration; proprietary inference acceleration reduces memory usage, complemented by open mainstream LLM APIs for faster product delivery.",
        results: {
          stability: {
            title: "System Stability Leap",
            desc: "Resolved flickering and distortion, improving system stability by 40%.",
          },
          efficiency: {
            title: "Efficiency Multiplied",
            desc: "Video creation processing efficiency improved by 6x, with significant reduction in per-video generation costs.",
          },
          business: {
            title: "Business Validation",
            desc: "Successfully supported landmark projects including Coca-Cola global marketing and Qatar Airways.",
          },
        },
        resultTitle: {
          h1: "Empowering Generative AI Unicorns",
          h2: "Supporting 300M+ AI Creative Asset Generation Globally",
        },
      },
      kreadoAi: {
        title: "KreadoAI | AIGC Marketing & AI Compute",
        challenge:
          "Leading AIGC marketing platform serving 100K+ enterprises and 200M+ monthly assets; multimodal training at PB scale slows iteration; peak inference strains GPUs and raises cost; vertical fine-tuning is slow.",
        solution:
          "Heterogeneous GPU elastic clusters for parallel training; optimized distributed frameworks (~60% shorter iteration); pruning & quantization for higher throughput and lower unit cost; APIs and toolchains cut industry adaptation from ~2 weeks to ~3 days.",
        results: {
          perf: {
            title: "Throughput at Peak",
            desc: "~260% higher peak concurrent capacity for traffic spikes.",
          },
          cost: {
            title: "Unit Economics",
            desc: "Per-asset generation cost down to ~$0.066.",
          },
          growth: {
            title: "Global Expansion",
            desc: "~30K overseas customers added in six months.",
          },
        },
        resultTitle: {
          h1: "End-to-End AIGC Efficiency",
          h2: "Scaling Training to Inference",
        },
      },
      qimiGames: {
        title: "Qimi Games | Mobile Gaming AI & Compute",
        challenge:
          "Global titles with 10M+ players; rules-based NPCs feel stiff; content pipelines are slow; small GPU pools cannot train many models in parallel or keep inference latency stable.",
        solution:
          "Elastic GPU pools for parallel training and higher utilization; LLM fine-tuning for dynamic NPC behavior; AIGC text APIs accelerate content; inference tuned from ~200ms to under ~50ms.",
        results: {
          experience: {
            title: "Engagement & Revenue",
            desc: "Flagship title: ~22% higher D30 retention, ~40% monthly revenue growth.",
          },
          efficiency: {
            title: "Content Velocity",
            desc: "Production cycle from ~3 months to ~18 days; ~3× team output.",
          },
          cost: {
            title: "Optimized Spend",
            desc: "Pay-as-you-go compute; ~40% lower total cost.",
          },
        },
        resultTitle: {
          h1: "Premium Mobile Game AI",
          h2: "Smarter NPCs & Faster Content",
        },
      },
      // New case data
      digitalEntertainment: {
        title: "Digital Entertainment | Global Platform Solution",
        challenge:
          "With the global expansion of its talent matrix, it faced high overseas live streaming latency, difficult multi-language content compliance, and slow real-time processing and analysis of massive user data.",
        solution:
          "We reduced network latency by deploying global CDN and multi-regional microservice architecture. Used AI to achieve real-time multi-language translation and intelligent content moderation, ensuring localized operations and content compliance. Built real-time data streaming pipelines and data warehouses to achieve unified analysis and intelligent recommendations for global user data.",
        results: {
          flow: {
            title: "Smooth Global Experience",
            desc: "Optimized network paths in various ways, reducing global access latency by over 50%.",
          },
          localization: {
            title: "Intelligent Content Localization",
            desc: "Supports real-time translation and intelligent content moderation for 20+ mainstream languages.",
          },
          engagement: {
            title: "Enhanced User Stickiness",
            desc: "Personalized intelligent recommendation model increased user stickiness by 30%.",
          },
        },
        resultTitle: {
          h1: "Building Global Entertainment Ecosystem",
          h2: "Achieving Global Reach and Monetization of 2 Billion Fans",
        },
      },
      sdwan: {
        title: "SD-WAN | Cloud-Native Network Solution",
        challenge:
          "Traditional MPLS private lines are expensive and slow to deploy, enterprise customers' multi-cloud environments need unified management, and global network node monitoring and intelligent O&M are complex.",
        solution:
          "We helped build a next-generation cloud-native SD-WAN platform. Replaced traditional expensive private lines with global backbone networks; achieved unified management and secure interconnection through multi-cloud management platforms; and built AI intelligent O&M platforms to provide network performance prediction and second-level fault recovery capabilities.",
        results: {
          performance: {
            title: "Network Performance Leap",
            desc: "Global network latency reduced by 60%, network availability reached 99.99%.",
          },
          deployment: {
            title: "Deployment Efficiency Improvement",
            desc: "Customer network deployment time shortened from months to days, expansion speed increased by 3 times.",
          },
          maintenance: {
            title: "O&M Cost Reduction",
            desc: "Network O&M costs reduced by 50%, bandwidth utilization increased by 40%.",
          },
        },
        resultTitle: {
          h1: "Serving Fortune 500: Millisecond Latency",
          h2: "99.99% High-Availability Global Network",
        },
      },
      crossBorderEcommerce: {
        title: "Cross-Border E-commerce | Global Technology Solution",
        challenge:
          "High global user access latency and high concurrent traffic, multi-product technical architecture and resource allocation need unified optimization, and must meet global payment and data compliance requirements.",
        solution:
          "We built high-performance, high-availability global e-commerce infrastructure. Deployed global CDN and intelligent load balancing to improve access performance; built GKE multi-region microservice architecture to support independent deployment and elastic scaling of multiple product lines; and integrated intelligent payment and compliance security systems to ensure cross-border payment and global compliance security.",
        results: {
          performance: {
            title: "Global Performance Enhancement",
            desc: "Global page loading speed improved by 70%, mobile conversion rate increased by 25%.",
          },
          infrastructure: {
            title: "Infrastructure Cost Optimization",
            desc: "Infrastructure costs reduced by 40%, O&M efficiency improved by 50%.",
          },
          experience: {
            title: "User Experience Upgrade",
            desc: "Global user satisfaction increased by 35%, customer retention rate improved by 20%.",
          },
        },
        resultTitle: {
          h1: "Supporting Three Product Lines' Global Business Expansion",
          h2: "New Overseas Market Revenue Share Reached 60%",
        },
      },
      gaming: {
        title: "Gaming | Global Technology Solution",
        challenge:
          "Need to ensure low-latency gaming experience for 800 million global users, process TB-level real-time analysis of game data, and achieve culture-based precision operations.",
        solution:
          "We built high-performance gaming infrastructure supporting 800 million+ users. Built global low-latency gaming infrastructure; constructed massive data processing and intelligent analysis platforms supporting millions of events per second; and utilized Firebase to quickly implement social, user tracking, and push notification functions.",
        results: {
          experience: {
            title: "Gaming Experience Enhancement",
            desc: "Global gaming latency reduced to within 50ms, user experience satisfaction increased by 45%.",
          },
          growth: {
            title: "Significant User Growth",
            desc: "New user acquisition cost reduced by 30%, user retention rate improved by 25%.",
          },
          monetization: {
            title: "Outstanding Commercialization Results",
            desc: "Advertising revenue increased by 35%, in-app purchase conversion rate improved by 20%.",
          },
        },
        resultTitle: {
          h1: "Supporting 800 Million+ Users' High-Performance Gaming Experience",
          h2: "Empowering Global Publishing of Cultural Games",
        },
      },
      gamingSocial: {
        title: "Gaming Social | Cultural Going Global Solution",
        challenge:
          "Competitive games need millisecond-level real-time synchronization, social products need to support global real-time audio-video interaction, and cultural content needs precise localization while meeting compliance requirements.",
        solution:
          "We built globalized gaming operation infrastructure. Through Firebase and Agones on GKE services, ensured real-time synchronization and social interaction in games; built VertexAI-powered cultural content localization platform to achieve translation, element adaptation, and intelligent moderation; and established massive data analysis systems.",
        results: {
          experience: {
            title: "Ultimate Global Experience",
            desc: "Gaming latency reduced to within 30ms, global user satisfaction increased by 40%.",
          },
          localization: {
            title: "Precise Cultural Communication",
            desc: "Cultural content localization accuracy reached 95%, cultural recognition improved by 50%.",
          },
          value: {
            title: "Business Value Enhancement",
            desc: "Overseas market revenue share increased to 45%, cultural going global ROI improved by 80%.",
          },
        },
        resultTitle: {
          h1: "National Cultural Export Key Enterprise",
          h2: "Helping Chinese Cultural Products Go Global",
        },
      },
      entertainment: {
        title: "Pan-Entertainment | Global Content Platform Solution",
        challenge:
          "Global low-cost distribution and smooth playback of 4K ultra-high definition content, AI personalized real-time recommendations under tens of millions of concurrent users, and high-concurrency real-time bullet screen community interaction.",
        solution:
          "We built a globalized content distribution and interaction platform. Achieved low-cost, high-quality intelligent distribution of 4K content through Media CDN; built multi-modal real-time personalized recommendation engines using VertexAI; and created globally distributed bullet screen systems supporting millisecond-level synchronization based on Firebase.",
        results: {
          viewing: {
            title: "Ultimate Viewing Experience",
            desc: "4K HDR content loading time reduced by 60%, playback stuttering rate decreased by 80%.",
          },
          recommendation: {
            title: "Precise Personalized Recommendations",
            desc: "User content discovery efficiency improved by 40%, average viewing time increased by 35%.",
          },
          community: {
            title: "Highly Active Community",
            desc: "Real-time interaction response time controlled within 50ms, user engagement increased by 50%.",
          },
        },
        resultTitle: {
          h1: "Achieving Ultimate Global User Viewing Experience and",
          h2: "Comprehensive Empowerment of Content Creators",
        },
      },
    },
    // Tag system
    tags: {
      manufacturing: "Manufacturing",
      digital: "Digital Transformation",
      retail: "Retail Chain",
      global: "Globalization",
      adtech: "AdTech",
      optimization: "Cost Optimization",
      finance: "FinTech",
      cloud: "Cloud Native",
      healthcare: "Healthcare",
      ai: "Artificial Intelligence",
      gaming: "Gaming",
      infrastructure: "Infrastructure",
      education: "Online Education",
      saas: "SaaS Platform",
      logistics: "Logistics",
      bigdata: "Big Data",
      media: "Media",
      streaming: "Streaming",
      // New tags
      entertainment: "Entertainment",
      sdwan: "SD-WAN",
      ecommerce: "E-commerce",
      socialGaming: "Social Gaming",
      culturalExport: "Cultural Export",
      contentPlatform: "Content Platform",
    },
    // Action buttons
    loadMore: "Load More Cases",
    loadMoreButton: "Load More",
    // Contact button
    contactUs: "Contact Us",
  },
  ja: {
    // ヒーローセクション
    hero: {
      title: "「真の顧客事例」ストーリーを紹介",
      titleHighlight: "グローバルビジネス成長を支援",
      description:
        "製造業、小売業、金融業、インターネット業界など様々な業界に跨り、真のビジネスニーズに基づいて<br />クラウドソリューションを設計し、お客様がコスト削減と同時により多くのイノベーション可能性を解放できるよう支援します。",
    },
    // 事例展示エリア
    section: {
      title: "成功事例",
      description:
        "私たちは業界をリードする企業と協力し、専門的なクラウドコスト管理ソリューションを通じて、大幅なコスト削減と効率向上を実現しています",
    },
    // 顧客事例リスト
    list: {
      tebian: {
        title: "特変電工",
        description:
          "世界的に有名な変圧器メーカーとして、特変電工はCycorのワンストップクラウドコスト管理ソリューションにより、マルチクラウド環境で30%のコスト削減と運用効率の大幅な向上を実現しました。",
      },
      kudi: {
        title: "KuDi Coffee",
        description:
          "急成長するコーヒーチェーンKuDiは、Cycorのクラウドリソース最適化ソリューションにより、グローバルビジネス拡張過程で精密なクラウドコスト制御と40%のリソース利用率向上を実現しました。",
      },
      zmaticoo: {
        title: "ZMaticoo",
        description:
          "業界をリードする広告技術会社として、ZMaticooはCycorのインテリジェント分析プラットフォームにより、ビッグデータ処理コストの25%削減とリアルタイム性能の大幅な最適化を実現しました。",
      },
      company4: {
        title: "イノベーションテック",
        description:
          "CycorのDevFinOpsソリューションにより、イノベーションテックはクラウドネイティブ変革過程で開発コストの可視化と35%のリソース最適化効果を実現しました。",
      },
      company5: {
        title: "医療ヘルスケア",
        description:
          "Cycorのマルチクラウド管理プラットフォームにより、医療ヘルスケア企業はコンプライアンス要件下で医療データ処理コストの20%削減を実現しました。",
      },
      company6: {
        title: "ゲームエンターテイメント",
        description:
          "Cycorの弾性リソース管理により、ゲーム会社はピークトラフィック処理で50%のコスト節約とユーザー体験の継続的な最適化を実現しました。",
      },
      company7: {
        title: "オンライン教育",
        description:
          "教育技術会社はCycorのSaaSコスト最適化ソリューションにより、ユーザー急成長期間中に安定した単位コスト制御を維持しました。",
      },
      company8: {
        title: "物流配送",
        description:
          "大型物流企業はCycorのビッグデータ分析ソリューションにより、輸送ルート最適化と倉庫コスト30%の効果的な削減を実現しました。",
      },
      company9: {
        title: "メディアストリーミング",
        description:
          "動画ストリーミングプラットフォームはCycorのCDN最適化ソリューションにより、グローバルコンテンツ配信で帯域幅コスト45%の大幅な節約を実現しました。",
      },
      // Akool事例
      akool: {
        title: "Akool｜生成AI算力ソリューション",
        challenge:
          "大規模トレーニングによるGPU不足でモデル更新が遅延；高並行レンダリングがVRAMコストを押し上げ；リアルタイム配信・会議での推論遅延がミリ秒要件を満たせない。",
        solution:
          "高性能GPU弾性クラスターで秒単位のスケーリングを実現；分散トレーニング最適化でモデル更新を加速；自社推論加速でVRAMを削減し、主流大モデルAPIで製品展開をサポート。",
        results: {
          stability: {
            title: "システム安定性の向上",
            desc: "ちらつき・変形を抑制し、システム安定性が40%向上。",
          },
          efficiency: {
            title: "効率の大幅向上",
            desc: "動画制作処理効率が6倍向上し、単一動画生成コストが大幅削減。",
          },
          business: {
            title: "ビジネスの実証",
            desc: "コカ・コーラのグローバルマーケティング、カタール航空などの標準事例を成功裏に支援。",
          },
        },
        resultTitle: {
          h1: "生成AIユニコーン企業を支援",
          h2: "世界3億以上のAIクリエイティブ資産生成をサポート",
        },
      },
      kreadoAi: {
        title: "KreadoAI｜AIGCマーケティング智算ソリューション",
        challenge:
          "世界をリードするAIGCマーケプラットフォーム、10万超企業・月間2億超アセット。マルチモーダル学習はPB級データで周期が長く、高並行推論でGPU競合とコスト上昇、業界向け微調整も遅い。",
        solution:
          "異種GPU弾性クラスタで並列学習を支援、分散フレーム最適化で周期を約60%短縮、剪定・量子化でスループット向上と単位コスト削減、APIとツールチェーンで業界適応を約2週間から約3日へ圧縮。",
        results: {
          perf: {
            title: "ピーク処理力",
            desc: "ピーク並行処理能力が約260%向上、大促にも対応。",
          },
          cost: {
            title: "単価改善",
            desc: "1件あたり生成コストを約0.066ドルまで削減。",
          },
          growth: {
            title: "市場拡大",
            desc: "半年で海外顧客約3万追加。",
          },
        },
        resultTitle: {
          h1: "AIGC全工程の効率化",
          h2: "学習から推論までのスケール展開",
        },
      },
      qimiGames: {
        title: "Qimi Games｜モバイルゲームAI智算ソリューション",
        challenge:
          "グローバル展開のヒット作、プレイヤー1000万超。ルールベースNPCは体験が単調、シナリオ生産周期が長く、小規模GPUでは並列学習と低遅延推論が難しい。",
        solution:
          "弾性GPUプールで並列学習と利用率向上、大モデル微調整で動的NPCを実現、AIGCテキストAPIでコンテンツ生産を効率化、推論遅延を約200msから約50ms未満へ。",
        results: {
          experience: {
            title: "体験・売上",
            desc: "代表作で30日リテンション約+22%、月次売上約+40%。",
          },
          efficiency: {
            title: "生産速度",
            desc: "コンテンツ周期を約3ヶ月から約18日へ、小チームで産出約3倍。",
          },
          cost: {
            title: "コスト最適化",
            desc: "従量課金で総コスト約40%削減。",
          },
        },
        resultTitle: {
          h1: "精品モバイルゲームのAI強化",
          h2: "NPC知能とコンテンツ産能の両立",
        },
      },
      // 新しい事例データ
      digitalEntertainment: {
        title:
          "デジタルエンターテインメント｜グローバルプラットフォームソリューション",
        challenge:
          "傘下のライバーとアーティストマトリックスのグローバル展開に伴い、海外でのライブ配信遅延が高く、多言語コンテンツコンプライアンスが困難で、大量のユーザーデータのリアルタイム処理と分析が遅いという課題に直面しました。",
        solution:
          "グローバルCDNと多地域マイクロサービスアーキテクチャを展開してネットワーク遅延を削減しました。AIを活用して多言語リアルタイム翻訳とインテリジェントコンテンツ審査を実現し、ローカライズされた運営とコンテンツコンプライアンスを確保しました。リアルタイムデータストリーミングパイプラインとデータウェアハウスを構築し、グローバルユーザーデータの統一分析とインテリジェントレコメンデーションを実現しました。",
        results: {
          flow: {
            title: "グローバル体験の流暢さ",
            desc: "様々な方法でネットワーク経路を最適化し、グローバルアクセス遅延50%以上削減しました。",
          },
          localization: {
            title: "コンテンツインテリジェントローカライゼーション",
            desc: "20+の主要言語でのリアルタイム翻訳とインテリジェントコンテンツ審査をサポートします。",
          },
          engagement: {
            title: "ユーザー粘着性向上",
            desc: "パーソナライズされたインテリジェントレコメンデーションモデルによりユーザー粘着性が30%向上しました。",
          },
        },
        resultTitle: {
          h1: "グローバルエンターテインメント生態系の構築",
          h2: "20億ファンのグローバルリーチと収益化を実現",
        },
      },
      sdwan: {
        title: "SD-WAN｜クラウドネイティブネットワークソリューション",
        challenge:
          "従来のMPLS専用線はコストが高く、デプロイが遅い。企業顧客のマルチクラウド環境の統一管理が必要で、グローバルネットワークノード監視とインテリジェント運用・保守が複雑です。",
        solution:
          "次世代クラウドネイティブSD-WANプラットフォームの構築を支援しました。グローバルバックボーンネットワークで従来の高価な専用線を置き換え、マルチクラウド管理プラットフォームを通じて統一管理と安全な相互接続を実現し、AIインテリジェント運用・保守プラットフォームを構築してネットワーク性能予測と秒レベルの障害回復機能を提供しました。",
        results: {
          performance: {
            title: "ネットワーク性能飛躍",
            desc: "グローバルネットワーク遅延60%削減、ネットワーク可用性99.99%達成。",
          },
          deployment: {
            title: "デプロイ効率向上",
            desc: "顧客ネットワークデプロイ時間を数ヶ月から数日に短縮、拡張速度3倍向上。",
          },
          maintenance: {
            title: "運用・保守コスト削減",
            desc: "ネットワーク運用・保守コスト50%削減、帯域幅利用率40%向上。",
          },
        },
        resultTitle: {
          h1: "世界トップ500企業にサービス提供：ミリ秒レベル遅延",
          h2: "99.99%高可用性グローバルネットワーク",
        },
      },
      crossBorderEcommerce: {
        title: "越境EC｜グローバル技術ソリューション",
        challenge:
          "グローバルユーザーアクセス遅延が大きく、高並行トラフィックで、複数の製品ラインの技術アーキテクチャとリソース配分の統一最適化が必要で、グローバル決済とデータコンプライアンス要件を満たす必要があります。",
        solution:
          "高性能、高可用性のグローバルEC基盤インフラを構築しました。グローバルCDNとインテリジェントロードバランシングを展開してアクセス性能を向上させ、GKE多地域マイクロサービスアーキテクチャを構築して複数製品ラインの独立デプロイと弾性拡張をサポートし、インテリジェント決済とコンプライアンスセキュリティシステムを統合して越境決済とグローバルコンプライアンスセキュリティを確保しました。",
        results: {
          performance: {
            title: "グローバル性能向上",
            desc: "グローバルページ読み込み速度70%向上、モバイル端末コンバージョン率25%向上。",
          },
          infrastructure: {
            title: "インフラストラクチャコスト最適化",
            desc: "インフラストラクチャコスト40%削減、運用・保守効率50%向上。",
          },
          experience: {
            title: "ユーザー体験アップグレード",
            desc: "グローバルユーザー満足度35%向上、顧客定着率20%向上。",
          },
        },
        resultTitle: {
          h1: "3つの製品ラインのグローバルビジネス拡張をサポート",
          h2: "新規海外市場収入比率60%達成",
        },
      },
      gaming: {
        title: "ゲームエンターテイメント｜グローバル技術ソリューション",
        challenge:
          "800万+グローバルユーザーへのミリ秒級ゲーム体験、TB級データのリアルタイム分析と文化精密運用が求められました。",
        solution:
          "800万+ユーザー対応の高性能低遅延ゲーム基盤を構築し、データ分析・ソーシャル・推送等を迅速実装しました。",
        results: {
          experience: {
            title: "ゲーム体験アップグレード",
            desc: "グローバルゲーム遅延50ms以内、グローバルユーザー満足度45%向上。",
          },
          growth: {
            title: "ゲームユーザー成長",
            desc: "新規ユーザー獲得コスト30%削減、ユーザー定着率25%向上。",
          },
          monetization: {
            title: "ゲーム収益化",
            desc: "広告収益35%向上、アプリ内課金コンバージョン率20%向上。",
          },
        },
        resultTitle: {
          h1: "グローバル800万以上のユーザーをサポートする高パフォーマンスゲーム基盤",
          h2: "文化ベースの精密運用を実現",
        },
      },
      gamingSocial: {
        title: "ゲームソーシャル｜文化輸出ソリューション",
        challenge:
          "競合ゲームはミリ秒級リアルタイム同期、ソーシャル製品はグローバル音声・ビデオ対話、文化コンテンツはローカライズとコンプライアンス対応が必要。",
        solution:
          "グローバルゲーム運営基盤を構築。FirebaseとAgonesでゲーム同期・ソーシャル対話、VertexAIで文化コンテンツのローカライズ・審査、大規模データ分析を実現。",
        results: {
          experience: {
            title: "グローバル体験の極致",
            desc: "ゲーム遅延30ms以内、グローバルユーザー満足度40%向上。",
          },
          localization: {
            title: "文化伝播の精密",
            desc: "文化コンテンツローカライズ正確率95%、文化認識度50%向上。",
          },
          value: {
            title: "文化輸出価値の最大化",
            desc: "海外市場収入比率45%向上、文化輸出ROI80%向上。",
          },
        },
        resultTitle: {
          h1: "国家文化輸出重点企業",
          h2: "中国文化製品の世界への輸出を支援",
        },
      },
      entertainment: {
        title:
          "パンエンターテインメント｜グローバルコンテンツプラットフォームソリューション",
        challenge:
          "4K超清内容のグローバル低コスト配信・スムーズ再生、千万人同時接続下のAIパーソナライズ推薦と高並行リアルタイム弾幕コミュニティ。",
        solution:
          "Media CDNで4K内容の低コスト高品質配信、VertexAIで多モーダル実時間推薦、Firebaseでグローバル分散弾幕システムを構築。",
        results: {
          viewing: {
            title: "グローバルユーザーの視聴体験の極致",
            desc: "4K HDRコンテンツの加载時間60%削減、再生ストッピング率80%削減。",
          },
          recommendation: {
            title: "コンテンツクリエイターの全面的な支援",
            desc: "コンテンツ発見効率40%向上、平均視聴時間35%増加。",
          },
          community: {
            title: "コミュニティの高度な活動",
            desc: "リアルタイムインタラクション応答時間50ms以内、ユーザー参加度50%向上。",
          },
        },
        resultTitle: {
          h1: "グローバルユーザーの視聴体験の極致と",
          h2: "コンテンツクリエイターの全面的な支援",
        },
      },
    },
    // タグシステム
    tags: {
      manufacturing: "製造業",
      digital: "デジタル変革",
      retail: "小売チェーン",
      global: "グローバル化",
      adtech: "広告技術",
      optimization: "コスト最適化",
      finance: "フィンテック",
      cloud: "クラウドネイティブ",
      healthcare: "医療ヘルスケア",
      ai: "人工知能",
      gaming: "ゲーム",
      infrastructure: "インフラストラクチャ",
      education: "オンライン教育",
      saas: "SaaSプラットフォーム",
      logistics: "物流",
      bigdata: "ビッグデータ",
      media: "メディア",
      streaming: "ストリーミング",
    },
    // アクションボタン
    loadMore: "もっと見る",
    loadMoreButton: "もっと見る",
    // お問い合わせボタン
    contactUs: "お問い合わせ",
  },
};
